import { render, staticRenderFns } from "./FundDistributionModal.vue?vue&type=template&id=a553b7a6&scoped=true"
import script from "./FundDistributionModal.vue?vue&type=script&lang=js"
export * from "./FundDistributionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a553b7a6",
  null
  
)

export default component.exports